import { render, staticRenderFns } from "./ResourcesMonitoringIndex.vue?vue&type=template&id=7f988f56&"
import script from "./ResourcesMonitoringIndex.vue?vue&type=script&lang=js&"
export * from "./ResourcesMonitoringIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports